import * as React from 'react';

import ArticleHubCard from 'bundles/shared-articles/components/hub-page/ArticleHubCard';
import type { ArticleCardProps } from 'bundles/shared-articles/types';
import { PAGE_TYPE } from 'bundles/unified-seo-content-common/constants';
import useEstimatedReadTimeData from 'bundles/unified-seo-content-common/hooks/useEstimatedReadTimeData';
import { getPageLink } from 'bundles/unified-seo-content-common/utils';

export const ArticleHubCardWithEstimatedReadTime = (
  props: ArticleCardProps & { slug: string; localizedCountryCode?: string }
) => {
  const { estimatedReadTimeLabel } = useEstimatedReadTimeData({ slug: props.slug });

  const { slug, localizedCountryCode } = props;

  return (
    <ArticleHubCard
      {...props}
      cardLink={getPageLink({ slug, localizedCountryCode, pageType: PAGE_TYPE.content })}
      estimatedReadTimeLabel={estimatedReadTimeLabel}
    />
  );
};

export default ArticleHubCardWithEstimatedReadTime;
